import { render, staticRenderFns } from "./Task-configs.vue?vue&type=template&id=0b3dafa9&"
import script from "./Task-configs.vue?vue&type=script&lang=js&"
export * from "./Task-configs.vue?vue&type=script&lang=js&"
import style0 from "./Task-configs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports